<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_08 col_12'><dynamic-field [id]='"scrntm"' [size]=8 [line]=1 [column]=12 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_29 col_26'><span class='brt high default' id='text1'>NRPC - STARS - TICKET INQUIRY</span>  </div>
  <div class='lgr_05 col_74'><span class='brt high default' id='text2'>S126G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_18 col_31'><span class='brt high default' id='text3'>COUPON INFORMATION</span>  </div>
  <div class='lgr_20 col_59'><dynamic-field [id]='"revnbr"' [size]=20 [line]=2 [column]=59 [(ngModel)]='revnbr'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_38 col_01'><span class='brt high default' id='text4'>CONTROL NUMBER  CJ    ORG/DST  DEPT DT</span>  </div>
  <div class='lgr_38 col_41'><span class='brt high default' id='text5'>ALOC1 AMOUNT1 INV.CODES  LFT DATE ADDL</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_33 col_01'><span class='brt high default' id='text6'>BOOK TICKET#    DOC   PRD/SUB TRN</span>  </div>
  <div class='lgr_44 col_35'><span class='brt high default' id='text7'># FEE ALOC2 AMOUNT2 PASSENGER LFT TRAIN USAG</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_34 col_01'><span class='brt high default' id='text8'>CONVERTED TKT#  DMY F/P RWB RR MKT</span>  </div>
  <div class='lgr_38 col_36'><span class='brt high default' id='text9'>PGM SOURCE/ID   AGR  TYPES   TRANS AMT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup1a"' [size]=79 [line]=7 [column]=1 [(ngModel)]='coup1a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup1b"' [size]=79 [line]=8 [column]=1 [(ngModel)]='coup1b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup1c"' [size]=79 [line]=9 [column]=1 [(ngModel)]='coup1c'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup2a"' [size]=79 [line]=11 [column]=1 [(ngModel)]='coup2a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup2b"' [size]=79 [line]=12 [column]=1 [(ngModel)]='coup2b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup2c"' [size]=79 [line]=13 [column]=1 [(ngModel)]='coup2c'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup3a"' [size]=79 [line]=15 [column]=1 [(ngModel)]='coup3a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup3b"' [size]=79 [line]=16 [column]=1 [(ngModel)]='coup3b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup3c"' [size]=79 [line]=17 [column]=1 [(ngModel)]='coup3c'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup4a"' [size]=79 [line]=19 [column]=1 [(ngModel)]='coup4a'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup4b"' [size]=79 [line]=20 [column]=1 [(ngModel)]='coup4b'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"coup4c"' [size]=79 [line]=21 [column]=1 [(ngModel)]='coup4c'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col'>
  <div class='lgr_03 col_07'><span class='brt high default' id='text10'>PF:</span>  </div>
  <div class='lgr_06 col_13'><span class='brt high default' id='text11'>4-EXIT</span>  </div>
  <div class='lgr_06 col_20'><span class='brt high default' id='text12'>3-MAIN</span>  </div>
  <div class='lgr_05 col_27'><dynamic-field [id]='"selmen"' [size]=5 [line]=23 [column]=27 [(ngModel)]='selmen'></dynamic-field></div>
  <div class='lgr_05 col_33'><span class='brt high default' id='text13'>5-ISS</span>  </div>
  <div class='lgr_06 col_39'><dynamic-field [id]='"prev"' [size]=6 [line]=23 [column]=39 [(ngModel)]='prev'></dynamic-field></div>
  <div class='lgr_06 col_46'><dynamic-field [id]='"next"' [size]=6 [line]=23 [column]=46 [(ngModel)]='next'></dynamic-field></div>
  <div class='lgr_08 col_54'><dynamic-field [id]='"usage"' [size]=8 [line]=23 [column]=54 [(ngModel)]='usage'></dynamic-field></div>
  <div class='lgr_07 col_63'><dynamic-field [id]='"pagt"' [size]=7 [line]=23 [column]=63 [(ngModel)]='pagt'></dynamic-field></div>
  <div class='lgr_08 col_71'><span class='brt high default' id='text14'>12-PRINT</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_09 col_01'><span class='brt high default' id='text15'>SHIFT PF:</span>  </div>
  <div class='lgr_12 col_11'><dynamic-field [id]='"currc1"' [size]=12 [line]=24 [column]=11 [(ngModel)]='currc1'></dynamic-field></div>
  <div class='lgr_17 col_25'><dynamic-field [id]='"prevc1"' [size]=17 [line]=24 [column]=25 [(ngModel)]='prevc1'></dynamic-field></div>
  <div class='lgr_09 col_44'><dynamic-field [id]='"paymt"' [size]=9 [line]=24 [column]=44 [(ngModel)]='paymt'></dynamic-field></div>
  <div class='lgr_08 col_55'><dynamic-field [id]='"last"' [size]=8 [line]=24 [column]=55 [(ngModel)]='last'></dynamic-field></div>
  <div class='lgr_09 col_65'><dynamic-field [id]='"first"' [size]=9 [line]=24 [column]=65 [(ngModel)]='first'></dynamic-field></div>
</div>
</div>
